import { useEffect } from 'react';

// Drawer slides in from the right with a backdrop. Closes on ESC or backdrop
// click. Full-width on mobile, fixed-width on md+.
export default function Drawer({ open, onClose, children }) {
  useEffect(() => {
    if (!open) return;
    const onKey = (e) => e.key === 'Escape' && onClose();
    window.addEventListener('keydown', onKey);
    return () => window.removeEventListener('keydown', onKey);
  }, [open, onClose]);

  return (
    <>
      <div
        onClick={onClose}
        aria-hidden
        className={`fixed inset-0 bg-black/40 z-40 transition-opacity ${
          open ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}`}
      />
      <aside
        role="dialog"
        aria-modal="true"
        className={`fixed top-0 right-0 h-full w-full sm:w-[22rem] z-50 bg-slate-900 border-l border-slate-800 shadow-2xl
                    overflow-y-auto transform transition-transform ${
                      open ? 'translate-x-0' : 'translate-x-full'}`}>
        <div className="sticky top-0 z-10 bg-slate-900 border-b border-slate-800 px-4 h-12 flex items-center justify-between">
          <span className="text-sm font-semibold text-slate-200">Settings</span>
          <button
            onClick={onClose}
            aria-label="close"
            className="p-1.5 rounded hover:bg-slate-800 text-slate-300">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <path d="M18 6L6 18M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div className="p-4">{children}</div>
      </aside>
    </>
  );
}
